Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.ClaimMessage

  @TYPE = 'reclameaqui'

  constructor: (data) ->
    @data = data

  getJson: ->
    @data

  getGroupType: ->
    "reclameaqui"

  getType: ->
    "reclameaqui"

  getSubType: ->
    "claim-message"

  getPrivacy: ->
    'private'

  getContentId: ->
    @data.content_id

  isBrandContent: ->
    @data.indice == -1 || false

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    false

  getAuthorId: ->
    @data.interaction.author.id

  getAuthorName: ->
    @data.interaction.author.name

  getAvatar: ->
    tail = if @isBrandContent() then 'brand.png' else 'user.png'
    window.image_path("#{@getType()}-#{tail}")

  getCreatedAt: ->
    Date.create(@data.data)

  getMainText: ->
    @data.mensagem

  getAuthorUsername: ->
    ''
